export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  description: string;
  longDescription: string;
  status: string;
  rating: number;
  views: number;
  updatedAt: string;
  chapters: ComicChapter[];
  tags: string[];
  publishDate: string;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-global-line' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line' },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-calendar-line' },
  { name: '耽美', slug: 'bl', icon: 'ri-star-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '我的霸道总裁',
    author: '金作家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20elegant%20couple%20silhouette%20against%20warm%20sunset%20cityscape%2C%20soft%20watercolor%20texture%2C%20clean%20composition%2C%20manga%20illustration%20with%20dreamy%20atmosphere%2C%20soft%20pink%20and%20gold%20tones%2C%20minimalist%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '普通上班族林小美意外邂逅霸道总裁，从此她的人生彻底改变。一段甜蜜又纠结的都市恋情就此展开。',
    longDescription: '林小美是一家小公司的普通职员，生活平淡无奇。直到有一天，她在电梯里不小心将咖啡洒在了盛世集团总裁顾北辰的西装上。本以为会丢掉工作，没想到这位以冷酷著称的总裁却对她产生了兴趣。从此，林小美的生活天翻地覆——豪华晚宴、私人飞机、昂贵礼物接踵而至。但豪门的世界并不简单，她能否在爱情与自我之间找到平衡？一段笑中带泪的都市浪漫故事，带你感受不一样的爱情。',
    status: '连载中',
    rating: 4.8,
    views: 1280000,
    updatedAt: '2026-08-04',
    publishDate: '2026-01-15',
    chapters: [
      { id: 'ch1-1', title: '第1话 意外的相遇', number: 1, updatedAt: '2026-01-15' },
      { id: 'ch1-2', title: '第2话 总裁的特别关注', number: 2, updatedAt: '2026-01-22' },
      { id: 'ch1-3', title: '第3话 第一次约会', number: 3, updatedAt: '2026-01-29' },
      { id: 'ch1-4', title: '第4话 前女友的出现', number: 4, updatedAt: '2026-02-05' },
      { id: 'ch1-5', title: '第5话 危机时刻', number: 5, updatedAt: '2026-02-12' },
      { id: 'ch1-6', title: '第6话 真心的告白', number: 6, updatedAt: '2026-02-19' },
    ],
    tags: ['恋爱', '都市', '霸道总裁', '甜宠'],
  },
  {
    id: '2',
    title: '异世界冒险录',
    author: '李漫画家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20epic%20adventurer%20with%20magic%20staff%20in%20mystical%20forest%2C%20glowing%20runes%20and%20magical%20creatures%2C%20vibrant%20emerald%20and%20gold%20colors%2C%20detailed%20manga%20illustration%2C%20clean%20composition%2C%20warm%20ambient%20lighting&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '高中生韩宇被召唤到异世界，发现自己拥有独一无二的魔法天赋。为了回到原来的世界，他踏上冒险之旅。',
    longDescription: '平凡的高中生韩宇在某天放学路上被一道神秘的光芒带到了剑与魔法的世界——艾瑟兰大陆。在这里，他发现自己拥有前所未有的魔法天赋，能够同时掌握元素魔法和治愈魔法。为了寻找回家的方法，他加入了冒险者公会，结识了精灵弓箭手莉亚、兽人战士雷格和神秘法师艾琳。随着冒险的深入，一个威胁整个大陆的黑暗阴谋逐渐浮出水面。韩宇能否在拯救世界的同时找到回家的路？',
    status: '连载中',
    rating: 4.9,
    views: 2350000,
    updatedAt: '2026-08-03',
    publishDate: '2026-02-20',
    chapters: [
      { id: 'ch2-1', title: '第1话 来自异世界的召唤', number: 1, updatedAt: '2026-02-20' },
      { id: 'ch2-2', title: '第2话 冒险者公会', number: 2, updatedAt: '2026-02-27' },
      { id: 'ch2-3', title: '第3话 第一次任务', number: 3, updatedAt: '2026-03-05' },
      { id: 'ch2-4', title: '第4话 暗影森林', number: 4, updatedAt: '2026-03-12' },
      { id: 'ch2-5', title: '第5话 远古遗迹', number: 5, updatedAt: '2026-03-19' },
    ],
    tags: ['奇幻', '异世界', '冒险', '魔法'],
  },
  {
    id: '3',
    title: '校园风云',
    author: '赵漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%20art%2C%20group%20of%20students%20in%20school%20uniforms%20on%20rooftop%2C%20cherry%20blossom%20petals%2C%20bright%20sunny%20day%2C%20youthful%20and%20energetic%20vibe%2C%20clean%20manga%20illustration%20style%2C%20soft%20pastel%20colors%2C%20warm%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '喜剧',
    categorySlug: 'comedy',
    description: '转学生陈小凡来到新学校，凭借幽默感和正义感，迅速成为校园风云人物，展开了一段爆笑又温馨的校园生活。',
    longDescription: '陈小凡因为父母工作调动，转学到了阳光高中。第一天就因为误打误撞帮学生会主席解决了难题而名声大噪。他组建了校园搞笑社团，带领一群性格各异的同学——学霸班长、体育健将、宅男漫画家、毒舌美少女——一起经历了文化祭、运动会、修学旅行等一系列让人捧腹大笑的校园事件。在与同学们相处的过程中，陈小凡也逐渐收获了珍贵的友情和懵懂的爱情。',
    status: '已完结',
    rating: 4.6,
    views: 890000,
    updatedAt: '2026-07-20',
    publishDate: '2025-09-01',
    chapters: [
      { id: 'ch3-1', title: '第1话 转学生登场', number: 1, updatedAt: '2025-09-01' },
      { id: 'ch3-2', title: '第2话 搞笑社团成立', number: 2, updatedAt: '2025-09-08' },
      { id: 'ch3-3', title: '第3话 文化祭大作战', number: 3, updatedAt: '2025-09-15' },
      { id: 'ch3-4', title: '第4话 运动会风云', number: 4, updatedAt: '2025-09-22' },
      { id: 'ch3-5', title: '第5话 毕业季', number: 5, updatedAt: '2025-09-29' },
    ],
    tags: ['校园', '喜剧', '青春', '日常'],
  },
  {
    id: '4',
    title: '暗夜追踪者',
    author: '王编剧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20detective%20silhouette%20in%20rainy%20alley%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20dark%20moody%20tone%2C%20clean%20manga%20illustration%2C%20deep%20shadows%20and%20warm%20accent%20lights&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    description: '刑警队长周明宇追查连环失踪案，线索指向一个神秘的暗网组织。真相远比想象中更加可怕。',
    longDescription: '繁华都市的暗处，一连串失踪案件让警方束手无策。刑警队长周明宇临危受命，接手这起看似毫无关联的连环失踪案。随着调查深入，他发现所有线索都指向一个叫"暗夜"的神秘暗网组织。这个组织的成员遍布各行各业，他们用加密通讯进行联络，用虚拟货币交易非法物品。更让人不寒而栗的是，组织的幕后主使似乎与周明宇的过去有着千丝万缕的联系。在真相与危险之间，周明宇必须做出选择。',
    status: '连载中',
    rating: 4.7,
    views: 1560000,
    updatedAt: '2026-08-02',
    publishDate: '2026-03-10',
    chapters: [
      { id: 'ch4-1', title: '第1话 失踪', number: 1, updatedAt: '2026-03-10' },
      { id: 'ch4-2', title: '第2话 第一个线索', number: 2, updatedAt: '2026-03-17' },
      { id: 'ch4-3', title: '第3话 暗网', number: 3, updatedAt: '2026-03-24' },
      { id: 'ch4-4', title: '第4话 卧底', number: 4, updatedAt: '2026-03-31' },
    ],
    tags: ['悬疑', '推理', '都市', '犯罪'],
  },
  {
    id: '5',
    title: '我的邻居是吸血鬼',
    author: '韩漫画家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20vampire%20romance%20cover%20art%2C%20mysterious%20handsome%20vampire%20in%20modern%20apartment%2C%20moonlight%20streaming%20through%20window%2C%20gothic%20yet%20modern%20aesthetic%2C%20deep%20crimson%20and%20silver%20tones%2C%20clean%20manga%20illustration%2C%20romantic%20and%20mysterious%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '独居女孩苏晓乔发现隔壁搬来了一位神秘帅哥，他只在夜晚出门，而且从不吃东西...',
    longDescription: '刚毕业的苏晓乔搬进了市区的一套小公寓，开始了独居生活。她的隔壁住着一位极其英俊但异常神秘的男子——陆夜宸。他总是穿着黑色西装，只在夜晚出门，从不在白天露面。苏晓乔送去的食物永远被完好地退回。好奇心驱使她开始暗中观察这位神秘邻居，却意外发现了令人震惊的真相——他是一名活了数百年的吸血鬼。而更令人意想不到的是，苏晓乔身上似乎藏着与陆夜宸命运相连的秘密。一段跨越种族的禁忌之恋，在月光下悄然绽放。',
    status: '连载中',
    rating: 4.5,
    views: 980000,
    updatedAt: '2026-08-04',
    publishDate: '2026-04-01',
    chapters: [
      { id: 'ch5-1', title: '第1话 新邻居', number: 1, updatedAt: '2026-04-01' },
      { id: 'ch5-2', title: '第2话 深夜的秘密', number: 2, updatedAt: '2026-04-08' },
      { id: 'ch5-3', title: '第3话 意外的发现', number: 3, updatedAt: '2026-04-15' },
      { id: 'ch5-4', title: '第4话 吸血鬼的过去', number: 4, updatedAt: '2026-04-22' },
    ],
    tags: ['恋爱', '吸血鬼', '都市', '奇幻'],
  },
  {
    id: '6',
    title: '剑圣重生',
    author: '刘作家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20cover%20art%2C%20warrior%20holding%20glowing%20sword%20on%20battlefield%2C%20epic%20scale%2C%20dramatic%20clouds%2C%20warm%20sunset%20light%2C%20powerful%20stance%2C%20clean%20manga%20illustration%2C%20golden%20and%20crimson%20tones&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '一代剑圣陨落后重生为废材少年，凭借前世记忆重新踏上武道巅峰，剑指苍穹！',
    longDescription: '天元大陆第一剑圣——凌云天，在与魔教教主的决战中陨落。当他再次睁开眼睛时，发现自己重生成为了一个被称为"废材"的少年。在这个以实力为尊的世界，没有灵根的凌云天受尽欺凌。但他并不气馁，前世数百年的剑道感悟和战斗经验深深刻在灵魂之中。从最基础的剑法开始，他一步步重修武道，炼丹、炼器、阵法无所不精。昔日的敌人、今生的羁绊，都将在这条逆天之路上与他相遇。',
    status: '连载中',
    rating: 4.9,
    views: 3100000,
    updatedAt: '2026-08-04',
    publishDate: '2026-01-01',
    chapters: [
      { id: 'ch6-1', title: '第1话 陨落与重生', number: 1, updatedAt: '2026-01-01' },
      { id: 'ch6-2', title: '第2话 废材之名', number: 2, updatedAt: '2026-01-08' },
      { id: 'ch6-3', title: '第3话 初露锋芒', number: 3, updatedAt: '2026-01-15' },
      { id: 'ch6-4', title: '第4话 宗门大比', number: 4, updatedAt: '2026-01-22' },
      { id: 'ch6-5', title: '第5话 秘境探险', number: 5, updatedAt: '2026-01-29' },
      { id: 'ch6-6', title: '第6话 剑意初成', number: 6, updatedAt: '2026-02-05' },
    ],
    tags: ['动作', '重生', '玄幻', '武侠'],
  },
  {
    id: '7',
    title: '猫咪咖啡厅',
    author: '张漫画家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cozy%20cat%20cafe%20interior%20with%20cute%20cats%20and%20barista%2C%20warm%20sunlight%20through%20windows%2C%20relaxing%20atmosphere%2C%20soft%20pastel%20colors%2C%20clean%20manga%20illustration%2C%20heartwarming%20vibe&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '辞职青年何小涛开了一家猫咪咖啡厅，在这里遇见了各种各样的人和猫，找到了生活的意义。',
    longDescription: '厌倦了996工作生活的何小涛，毅然辞职，用全部积蓄在一条安静的老街上开了一家猫咪咖啡厅——"猫的时间"。咖啡厅里收养了五只性格迥异的猫咪：高冷的橘猫大王、黏人的布偶公主、贪吃的英短团子、好奇的美短跳跳和慵懒的加菲懒懒。每天都有形形色色的客人光临：失恋的大学生、退休的老教授、独自打拼的职场新人、寻找灵感的作家。在猫咪的陪伴和咖啡的香气中，何小涛倾听着每个人的故事，也慢慢找到了属于自己的人生方向。',
    status: '已完结',
    rating: 4.7,
    views: 720000,
    updatedAt: '2026-06-30',
    publishDate: '2025-06-01',
    chapters: [
      { id: 'ch7-1', title: '第1话 辞职与开张', number: 1, updatedAt: '2025-06-01' },
      { id: 'ch7-2', title: '第2话 第一位客人', number: 2, updatedAt: '2025-06-08' },
      { id: 'ch7-3', title: '第3话 猫咪大作战', number: 3, updatedAt: '2025-06-15' },
      { id: 'ch7-4', title: '第4话 雨天的来客', number: 4, updatedAt: '2025-06-22' },
    ],
    tags: ['日常', '治愈', '咖啡厅', '猫咪'],
  },
  {
    id: '8',
    title: '星际佣兵',
    author: '孙编剧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20action%20cover%20art%2C%20space%20mercenary%20in%20futuristic%20armor%20with%20plasma%20rifle%2C%20starship%20interior%20background%2C%20neon%20holographic%20displays%2C%20cool%20metallic%20tones%2C%20clean%20manga%20illustration%2C%20dynamic%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '公元2450年，退役特种兵叶无尘成为星际佣兵，穿梭于银河系完成各种危险任务。',
    longDescription: '公元2450年，人类已经遍布银河系的各个角落。退役特种兵叶无尘离开军方后，加入了宇宙中最负盛名的佣兵组织——星痕。从保护星际商船到探索未知星球，从追捕星际逃犯到对抗外星生物，叶无尘和他的队友们经历了无数次惊心动魄的冒险。在一次看似普通的护送任务中，他们意外发现了一个足以改变银河系格局的秘密。各方势力闻风而动，昔日的伙伴也可能变成敌人。在这片浩瀚星海中，忠诚与背叛只有一线之隔。',
    status: '连载中',
    rating: 4.6,
    views: 1890000,
    updatedAt: '2026-08-01',
    publishDate: '2026-03-01',
    chapters: [
      { id: 'ch8-1', title: '第1话 退役', number: 1, updatedAt: '2026-03-01' },
      { id: 'ch8-2', title: '第2话 加入星痕', number: 2, updatedAt: '2026-03-08' },
      { id: 'ch8-3', title: '第3话 第一次任务', number: 3, updatedAt: '2026-03-15' },
      { id: 'ch8-4', title: '第4话 外星遗迹', number: 4, updatedAt: '2026-03-22' },
    ],
    tags: ['科幻', '动作', '星际', '冒险'],
  },
  {
    id: '9',
    title: '甜蜜的谎言',
    author: '陈漫画家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20cover%20art%2C%20elegant%20woman%20and%20man%20facing%20away%20from%20each%20other%2C%20rainy%20window%20with%20city%20lights%2C%20melancholic%20yet%20beautiful%20atmosphere%2C%20soft%20blue-grey%20and%20rose%20tones%2C%20clean%20manga%20illustration&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '为了还债，沈佳宜假扮富家千金接近商业大亨陆子昂，却在一场精心设计的骗局中付出了真心。',
    longDescription: '沈佳宜本是一个普通的白领，因为父亲欠下巨额赌债，不得不想尽办法筹钱。在闺蜜的建议下，她伪造身份假扮成某财团的千金小姐，接近了商界最年轻有为的商业大亨——陆子昂。计划很顺利，陆子昂对她一见倾心，两人迅速坠入爱河。然而谎言总有被揭穿的一天。当真相浮出水面，陆子昂会原谅她吗？更让沈佳宜没想到的是，在这场骗局中，最先沦陷的竟是自己的心。爱始于谎言，却终于真心。',
    status: '已完结',
    rating: 4.4,
    views: 1650000,
    updatedAt: '2026-07-15',
    publishDate: '2025-10-01',
    chapters: [
      { id: 'ch9-1', title: '第1话 绝境', number: 1, updatedAt: '2025-10-01' },
      { id: 'ch9-2', title: '第2话 伪装', number: 2, updatedAt: '2025-10-08' },
      { id: 'ch9-3', title: '第3话 初遇', number: 3, updatedAt: '2025-10-15' },
      { id: 'ch9-4', title: '第4话 心动', number: 4, updatedAt: '2025-10-22' },
      { id: 'ch9-5', title: '第5话 真相', number: 5, updatedAt: '2025-10-29' },
    ],
    tags: ['恋爱', '都市', '虐恋', '契约'],
  },
  {
    id: '10',
    title: '美食猎人',
    author: '林漫画家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cooking%20adventure%20cover%20art%2C%20chef%20with%20exaggerated%20reaction%20to%20delicious%20food%2C%20vibrant%20ingredients%20and%20dishes%2C%20energetic%20and%20fun%20atmosphere%2C%20warm%20appetizing%20colors%2C%20clean%20manga%20illustration%2C%20dynamic%20food%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '喜剧',
    categorySlug: 'comedy',
    description: '吃货少年方大圆踏上寻找传说中的"神之食谱"的旅程，一路吃遍天下美食，笑料百出。',
    longDescription: '方大圆人如其名，是个为了美食可以不顾一切的吃货少年。在他十八岁生日那天，已故的爷爷寄来了一封神秘信件和半张残缺的食谱。信中写道：找到完整的"神之食谱"，就能做出传说中让人获得幸福的料理。于是，方大圆背上行囊，踏上了寻找食谱之旅。从街头小吃到米其林餐厅，从深山野味到深海珍馐，他尝遍了天下美食，也结识了一群志同道合的伙伴——毒舌美食评论家、天才小厨娘、神秘食材猎人。每一道料理背后都有一个温暖的故事，而"神之食谱"的真相，远比美食本身更让人感动。',
    status: '连载中',
    rating: 4.5,
    views: 670000,
    updatedAt: '2026-07-28',
    publishDate: '2026-05-01',
    chapters: [
      { id: 'ch10-1', title: '第1话 爷爷的遗愿', number: 1, updatedAt: '2026-05-01' },
      { id: 'ch10-2', title: '第2话 传说中的红烧肉', number: 2, updatedAt: '2026-05-08' },
      { id: 'ch10-3', title: '第3话 天才小厨娘', number: 3, updatedAt: '2026-05-15' },
      { id: 'ch10-4', title: '第4话 深山寻菇记', number: 4, updatedAt: '2026-05-22' },
    ],
    tags: ['喜剧', '美食', '冒险', '治愈'],
  },
  {
    id: '11',
    title: '幽灵侦探',
    author: '周作家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20mystery%20cover%20art%2C%20detective%20with%20ghostly%20figure%20behind%2C%20foggy%20old%20town%20street%2C%20eerie%20yet%20stylish%20atmosphere%2C%20muted%20teal%20and%20warm%20amber%20accents%2C%20clean%20manga%20illustration&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    description: '能看见鬼魂的大学生江小白，与幽灵搭档破案，揭开一个个悬案背后的真相。',
    longDescription: '大学生江小白在一次意外事故后，获得了看见鬼魂的能力。起初他对此恐惧不已，直到遇到了一位因冤案而死的刑警幽灵——老陈。老陈请求江小白帮忙调查当年的真相。在破案过程中，江小白发现自己不仅能看见鬼魂，还能通过与鬼魂沟通获取破案的关键线索。于是，一人一鬼组成了奇特的侦探搭档。他们接手了多起看似无法破解的悬案——密室杀人、连环失踪、多年前的冤案。每一个案子背后，都隐藏着人性的复杂与幽暗。',
    status: '连载中',
    rating: 4.8,
    views: 1120000,
    updatedAt: '2026-08-03',
    publishDate: '2026-04-15',
    chapters: [
      { id: 'ch11-1', title: '第1话 我能看见鬼', number: 1, updatedAt: '2026-04-15' },
      { id: 'ch11-2', title: '第2话 刑警老陈', number: 2, updatedAt: '2026-04-22' },
      { id: 'ch11-3', title: '第3话 十年前的冤案', number: 3, updatedAt: '2026-04-29' },
      { id: 'ch11-4', title: '第4话 密室之谜', number: 4, updatedAt: '2026-05-06' },
    ],
    tags: ['悬疑', '灵异', '推理', '都市'],
  },
  {
    id: '12',
    title: '花与剑',
    author: '杨漫画家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20cover%20art%2C%20beautiful%20warrior%20woman%20in%20traditional%20hanbok%20with%20sword%2C%20cherry%20blossom%20garden%2C%20elegant%20and%20powerful%2C%20soft%20pink%20and%20jade%20green%20tones%2C%20clean%20manga%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '朝鲜时代，女扮男装的剑客花妍为报父仇潜入宫中，却与敌国王子坠入禁忌之恋。',
    longDescription: '朝鲜时代，武官之女花妍的父亲被诬陷谋反而满门抄斩，唯有她侥幸逃生。为了洗清父亲的冤屈，她女扮男装苦练剑术十年，最终以"花无影"之名潜入宫中成为侍卫。在宫中，她遇到了前来作为人质的敌国王子——李昀。李昀表面温文尔雅，实则暗藏锋芒。两人在暗流涌动的宫廷中相互试探、彼此扶持。然而当花妍发现李昀可能与父亲的冤案有关时，爱恨交织，她的剑将指向何方？一段发生在乱世中的爱恨情仇，如同花与剑，美艳而危险。',
    status: '连载中',
    rating: 4.7,
    views: 1430000,
    updatedAt: '2026-08-02',
    publishDate: '2026-02-01',
    chapters: [
      { id: 'ch12-1', title: '第1话 灭门', number: 1, updatedAt: '2026-02-01' },
      { id: 'ch12-2', title: '第2话 十年磨一剑', number: 2, updatedAt: '2026-02-08' },
      { id: 'ch12-3', title: '第3话 潜入宫中', number: 3, updatedAt: '2026-02-15' },
      { id: 'ch12-4', title: '第4话 敌国王子', number: 4, updatedAt: '2026-02-22' },
    ],
    tags: ['动作', '古风', '恋爱', '复仇'],
  },
];

export const faqData = [
  {
    question: '奇漫屋是什么？',
    answer: '奇漫屋是一个专注于韩国漫画的免费在线阅读平台。我们提供丰富多样的韩漫资源，支持在线浏览和下拉式阅读，让您随时随地享受精彩的韩国漫画。所有内容经过精心挑选，确保画质清晰、翻译准确。',
  },
  {
    question: '奇漫屋的漫画是免费的吗？',
    answer: '是的，奇漫屋目前提供的所有韩国漫画均为免费阅读。我们致力于为漫画爱好者打造一个无门槛的阅读空间，无需付费即可畅享海量韩漫资源。未来如有付费内容，我们会提前公告。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过多种方式找到心仪的漫画：在首页的分类导航中按类型浏览（恋爱、奇幻、动作、悬疑等），使用搜索功能输入漫画名称或作者，或浏览"热门排行"和"最新更新"板块发现热门作品。',
  },
  {
    question: '支持什么设备阅读？',
    answer: '奇漫屋采用响应式设计，完美适配电脑、平板和手机等各种设备。无论您使用什么设备访问，都能获得流畅舒适的下拉式阅读体验。推荐使用Chrome、Safari等现代浏览器获得最佳效果。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '漫画的更新频率因作品而异。热门连载漫画通常每周更新1-2话，部分作品可能更新频率不同。您可以在每部漫画的详情页查看最近更新时间，建议收藏喜欢的漫画以便及时获取更新通知。',
  },
  {
    question: '如何联系奇漫屋？',
    answer: '您可以通过"关于我们"页面中的联系表单与我们取得联系，或发送邮件至我们的官方邮箱。我们欢迎任何关于内容建议、合作意向或使用问题的反馈，团队会尽快回复您的消息。',
  },
];